<template>
  <div class="c-table" ref="documenttable">
    <el-table
      ref="dataTable"
      class="summary-el-table-styles common-el-table-styles"
      :summary-method="getSummaries"
      show-summary
      v-loading="loading"
      :data="data"
      :height="height"
      border
      stripe
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
      >
        <template slot="header" slot-scope="scope">
          <template v-if="col.key === 'amountDiff'">
            <span>总消耗差异(爬取-天工)</span>
            <el-button @click.stop="showBatchSyncModal(scope)" v-if="isEnableBatchSync" type="text">批量同步</el-button>
          </template>
          <span v-else> {{ col.title }} </span>
        </template>
        <template slot-scope="scope">
          <span v-if="['tdate'].includes(col.key)">
            {{ scope.row[col.key] | datetimeToMonth }}
          </span>
          <span v-else-if="['lastSynTime'].includes(col.key)">
            {{ scope.row[col.key] | datetimeToSec }}
          </span>
          <span v-else-if="['dataModel'].includes(col.key)">
            {{ scope.row[col.key] | dataModelToText }}
          </span>
          <span class="flex-between" v-else-if="['amountDiff'].includes(col.key)">
            <span>{{ scope.row[col.key] }}</span>
            <el-button @click="sysData(scope.row)" v-if="scope.row[col.key] !== 0 && scope.row.taskId" type="text">同步数据</el-button>
          </span>
          <span class="flex-between" v-else-if="['synStatusDesc'].includes(col.key)">
            <span>{{ scope.row[col.key] === null ? '-' : scope.row[col.key] }}</span
            ><el-button @click="runData(scope.row)" v-if="scope.row.synStatus !== 1" type="text">重新同步</el-button>
          </span>
          <span v-else-if="['failMsg'].includes(col.key)">
            <span>{{ scope.row[col.key] === null ? '-' : scope.row[col.key] }}</span>
          </span>
          <span
            v-else-if="
              [
                'finaPaperAmount',
                'finaGiveAmount',
                'finaShareGiveAmount',
                'income',
                'balance',
                'paperBalance',
                'grantBalance',
                'shareBalance'
              ].includes(col.key)
            "
            >{{ scope.row[col.key] | formatNumber(col, scope) }}
          </span>
          <span
            v-else-if="
              [
                'paperUseAmount',
                'giveAmount',
                'principalAmount',
                'principalGiveAmount',
                'principalShareGiveAmount',
                'principalBalance',
                'principalPaperBalance',
                'principalGrantBalance',
                'principalShareBalance'
              ].includes(col.key)
            "
            >{{ scope.row[col.key] === null ? '0' : scope.row[col.key] }}</span
          >
          <span v-else>{{ scope.row[col.key] === null ? '' : scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="同步数据" :visible.sync="jobSycModal" width="500px" :close-on-click-modal="false" append-to-body>
      <div class="c-form c-test">
        <el-form label-width="110px">
          <el-form-item label="媒体">
            <span>{{ currentRow.mediaName }}</span>
          </el-form-item>
          <el-form-item label="账号">
            <span>{{ currentRow.adAccount }}</span>
          </el-form-item>
          <el-form-item label="同步时间范围">
            <el-date-picker disabled v-model="datetime" type="month" style="width: 220px"> </el-date-picker>

            <div class="form-tips">
              <p>1.请选择有消耗的时间范围</p>
              <p>2.爬取的离线数据跨度天数不能超过31天</p>
              <p>3.时间跨度过长可能导致同步页面无反应</p>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jobSycModal = false">取消</el-button>
        <el-button type="primary" @click="sycJob" :loading="sycLoadingStatus">同步数据</el-button>
      </span>
    </el-dialog>

    <!-- 批量联调 -->
    <MediaDataSyncBatchModal
      :list.sync="MediaDataSyncBatchList"
      :visible.sync="showMediaDataSyncBatchModal"
      @refresh="$emit('on-refresh')"
    ></MediaDataSyncBatchModal>
  </div>
</template>
<script>
import { syndata } from '@/api/ptom.data.model'
import { timeout } from '@/common/js/utils'
import moment from 'moment'
import { MEDIAS } from '@/common/js/constants.js'
import MediaDataSyncBatchModal from '@/views/sysmana/tasksyc/components/media-batch-sync.vue'
import { dataModelData } from '@/views/sysmana/tasksyc/const.js'
export default {
  name: 'reconciliationtable',
  filters: {
    formatNumber(value, col, scope) {
      const { mediaId } = scope.row
      switch (col.key) {
        case 'finaPaperAmount':
        case 'balance':
          return value || '0'
        case 'finaGiveAmount':
        case 'finaShareGiveAmount':
        case 'income':
          if ([MEDIAS.TOUTIAO, MEDIAS.GDT, MEDIAS.KUAISHOU].includes(mediaId)) {
            return value || '0'
          }
          return value || '-'
        case 'paperBalance':
        case 'shareBalance':
          if ([MEDIAS.GDT].includes(mediaId)) {
            return value || '0'
          }
          return value || '-'
        case 'grantBalance':
          if ([MEDIAS.TOUTIAO, MEDIAS.GDT].includes(mediaId)) {
            return value || '0'
          }
          return value || '-'
      }
      return value
    },
    dataModelToText(value) {
      return value ? dataModelData.find((i) => i.id === value).name : ''
    }
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    summaryData: {
      type: Object,
      default() {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  components: { MediaDataSyncBatchModal },
  data: function () {
    return {
      showMediaDataSyncBatchModal: false,
      MediaDataSyncBatchList: [],
      sycLoadingStatus: false,
      jobSycModal: false,
      currentRow: {},
      datetime: ''
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.dataTable.doLayout()
    })
  },
  computed: {
    isEnableBatchSync() {
      return this.data.some((row) => row.amountDiff !== 0)
    }
  },
  methods: {
    showBatchSyncModal() {
      this.MediaDataSyncBatchList = this.data.filter((row) => row.amountDiff !== 0)
      this.showMediaDataSyncBatchModal = true
    },
    // 合计自定义
    getSummaries(param) {
      const { columns } = param
      const sums = []
      columns.forEach((column) => {
        const prop = column.property
        if (prop === 'tdate') {
          sums.push('汇总')
        } else {
          if (
            [
              'paperUseAmount',
              'giveAmount',
              'finaPaperAmount',
              'finaGiveAmount',
              'finaShareGiveAmount',
              'income',
              'balance',
              'paperBalance',
              'grantBalance',
              'shareBalance'
            ].includes(prop)
          ) {
            sums.push(this.summaryData[prop] === null ? '0' : this.summaryData[prop])
          } else {
            sums.push(this.summaryData[prop] === null ? '' : this.summaryData[prop])
          }
        }
      })
      return sums
    },
    runData(row) {
      this.$emit('run-data', row)
    },

    // 排序
    sortChange({ column, prop, order }) {
      this.$emit('sort-change', { column, prop, order })
    },
    sysData(row) {
      this.currentRow = row
      const month = moment(row.tdate).format('YYYY-MM')
      this.datetime = month
      this.jobSycModal = true
    },
    sycJob() {
      const [synBeginTime, synEndTime] = [this.datetime + '-01', moment(this.datetime).endOf('month').format('YYYY-MM-DD')]
      const params = { taskId: this.currentRow.taskId, synBeginTime, synEndTime, finance: true }
      if (params.synBeginTime && params.synEndTime) {
        this.sycLoadingStatus = true
        syndata(params)
          .then((data) => {
            if (data.result) {
              if (this.jobSycModal) {
                this.$message.success(data.msg)
              }
              this.sycLoadingStatus = false
              timeout(1000).then(() => {
                this.jobSycModal = false
                this.$emit('on-refresh')
              })
            } else {
              this.sycLoadingStatus = false
              if (this.jobSycModal) {
                this.$message.warning(data.msg)
              }
            }
          })
          .catch(() => {
            this.sycLoadingStatus = false
          })
      } else {
        this.$message.warning('请选择同步时间!')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  background-color: #fff;
  .flex-between {
    display: flex;
    justify-content: space-between;
  }
  .c-control-margin {
    margin: 0;
    padding: 0 6px;
  }
  .el-table {
    overflow: visible !important;
  }
}

.form-tips {
  color: #ff6400;
  font-size: 12px;
  line-height: 20px;
  margin-top: 10px;
}
</style>
